<template>
    <b-modal title="Interpreter"
             size="lg"
             class="font-weight-bold"
             centered
             no-close-on-backdrop
             v-model="dialogOpen"
             @hidden="onDialogHidden">
        <!--this binds the enter key to the insert event, i.e. makes the OK button the default button-->
        <vue-keypress key-event="keydown" :key-code="13" @success="handleEnterKey"></vue-keypress>
        <b-alert v-model="showErrors" variant="danger" dismissible>
            <div v-for="(error, index) in currentErrors" :key="index">
                <p>{{ error }}</p>
            </div>
        </b-alert>
        <div ref="inputFields">
            <b-form-row class="mt-3">
                <b-form-group label="Interpreter Surname"
                              label-for="interpreterSurname"
                              :class="colsClass">
                    <b-form-input name="interpreterSurname"
                                  v-model="interpreterSurname"
                                  autofocus>
                    </b-form-input>
                </b-form-group>
                <b-form-group label="Interpreter Other Names"
                              label-for="interpreterOtherNames"
                              :class="colsClass">
                    <b-form-input name="interpreterOtherNames"
                                  v-model="interpreterOtherNames">
                    </b-form-input>
                </b-form-group>
                <b-form-group v-if="languages.display"
                              label="Language"
                              label-for="language"
                              :class="colsClass">
                    <select2 name="language"
                             v-model="language"
                             :options="languages.list"
                             tags
                             allow-clear
                             in-b-modal></select2>
                </b-form-group>
                <b-form-group v-if="timestamp.display"
                              label="Time"
                              label-for="time"
                              :class="colsClass">
                    <b-form-input name="time"
                                  v-model="time"
                                  type="time">
                    </b-form-input>
                </b-form-group>
            </b-form-row>
            <b-form-row v-if="statusOptions">
                <b-form-group label="Status"
                              label-for="status"
                              class="col-md-6">
                    <b-form-radio-group name="status"
                                        v-model="status"
                                        stacked>
                        <template v-for="(statusOption, index) in statusOptions">
                            <vue-keypress key-event="keydown"
                                          :key-code="statusOption.shortcut.keyCode"
                                          :modifiers="statusOption.shortcut.modifiers"
                                          :preventDefault="true"
                                          @success="status = statusOption.value"
                                          :key="'keypress' + index"
                                          v-if="statusOption.shortcut"></vue-keypress>
                            <b-form-radio :value="statusOption.value" :key="'radio' + index">
                                {{ statusOption.text }}
                                <template v-if="statusOption.shortcut">
                                    ({{ statusOption.shortcut.text }})
                                </template>
                            </b-form-radio>
                        </template>
                    </b-form-radio-group>
                </b-form-group>
            </b-form-row>
        </div>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="danger" @click="reset">Reset</b-button>
            <b-button @click="cancel">Cancel</b-button>
            <b-button variant="success" @click="insert">OK</b-button>
        </template>
    </b-modal>
</template>

<script>
    import $ from 'jquery';
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import VueKeypress from 'vue-keypress';
    import { v4 as newUuid } from 'uuid';

    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import InputMixin from '../../mixins/InputMixin';
    import EventsMixin from '../../mixins/EventsMixin';
    import Select2 from '../Select2';

    Vue.use(BootstrapVue);

    export default {
        name: 'TopscribeIntgerpreterDialog',
        mixins: [DateTimeMixin, InputMixin, EventsMixin],
        components: {
            'vue-keypress': VueKeypress,
            'select2': Select2
        },
        model: {
            event: 'change',
            prop: 'active',

        },
        props: {
            configuration: {
                type: Object,
                default: null
            },
            active: {
                type: Boolean,
                default: false
            },
            mode: {
                type: String,
                default: 'insert',
                validator: function (value) {
                    // The value must match one of these strings
                    return (['insert', 'edit'].indexOf(value) !== -1);
                }
            },
            currentEditorSection: {
                default: null
            }
        },
        data: function () {
            return {
                dialogOpen: this.active,
                currentConfiguration: this.configuration,
                currentErrors: null,
                showErrors: false,
                status: null,
                interpreterSurname: null,
                interpreterOtherNames: null,
                language: null,
                time: null,

                sectionsInsertedEventData: null
            }
        },
        computed: {
            colsClass: function () {
                if (this.languages.display && this.timestamp.display) {
                    return "col-md-3";
                } else if (this.languages.display || this.timestamp.display) {
                    return "col-md-4";
                }
                return "col-md-6";
            },
            languages: function () {
                return {
                    list: (this.currentConfiguration == null) ? null : this.currentConfiguration.LanguageOptions,
                    display: (this.currentConfiguration != null && this.currentConfiguration.LanguageSelection != "hidden"),
                    required: (this.currentConfiguration != null && this.currentConfiguration.LanguageSelection == "required"),
                };
            },
            timestamp: function () {
                return {
                    display: (this.currentConfiguration != null && this.currentConfiguration.TimestampSelection != "hidden"),
                    required: (this.currentConfiguration != null && this.currentConfiguration.TimestampSelection == "required"),
                };
            },
            statusOptions: function () {
                if (this.currentConfiguration == null) return null;
                return this.currentConfiguration.StatusOptions;
            }
        },
        watch: {
            configuration: function () {
                this.currentConfiguration = this.configuration;
            },
            active: function () {
                if (this.active) {
                    //the dialog is about to open
                    this.currentErrors = null;
                    if (this.mode == 'edit') {
                        try {
                            var base64EncodedMetaData = $(this.currentEditorSection).data('metadata');
                            var metaData = JSON.parse(atob(base64EncodedMetaData));
                            this.status = metaData.Status;
                            this.interpreterSurname = metaData.InterpreterSurname;
                            this.interpreterOtherNames = metaData.InterpreterOtherNames;
                            this.language = metaData.Language;
                            this.time = (metaData.Time == null) ? null : this.formatDateTime(metaData.Time, 'HH:mm', true, true);
                        }
                        catch
                        {
                            console.warn('invalid metadata in section');
                        }
                    } else {
                        this.status = null;
                        this.interpreterSurname = null;
                        this.interpreterOtherNames = null;
                        this.language = null;
                        this.time = null;
                    }
                    this.sectionsInsertedEventData = null;
                }
                this.dialogOpen = this.active;
            },
            currentErrors: function () {
                this.showErrors = (this.currentErrors != null) && (this.currentErrors.length > 0);
            }
        },
        methods: {
            handleEnterKey: function (e) {
                if (this.isEventTargetWithinElement(e.event, this.$refs.inputFields)) {
                    this.insert();
                }
            },
            reset: function () {
                this.status = null;
                this.currentErrors = null;
            },
            insert: function () {
                this.currentErrors = []
                if (this.status == null) {
                    this.currentErrors.push('A interpreter status selection is required');
                }
                if ((this.interpreterSurname == null) || (this.interpreterSurname.trim().length == 0)) {
                    this.currentErrors.push('An interpreter surname is required');
                }
                if ((this.interpreterOtherNames == null) || (this.interpreterOtherNames.trim().length == 0)) {
                    this.currentErrors.push('An interpreter other name is required');
                }
                if ((this.language == null || this.language.trim().length == 0) && this.languages.required) {
                    this.currentErrors.push('A language is required');
                }
                if ((this.time == null || this.time.trim().length == 0) && this.timestamp.required) {
                    this.currentErrors.push('A time is required');
                }

                if (this.currentErrors.length == 0) {
                    var statusText = this.findOptionEntry(this.currentConfiguration.StatusOptions, this.status).text;
                    var time = ((this.time == null) || (this.time.trim().length == 0)) ? null : this.parseDateTime(this.time, 'HH:mm', true, true);
                    var metaData = {
                        SectionId: newUuid(),
                        Type: 'interpreter',
                        Status: this.status,
                        InterpreterSurname: this.interpreterSurname,
                        InterpreterOtherNames: this.interpreterOtherNames,
                        Language: this.language,
                        Time: time
                    }
                    var content = this.interpreterOtherNames.trim() + ' ' + this.interpreterSurname.trim() + ', ';
                    content += statusText.toUpperCase();
                    content += ' TO INTERPRET';
                    content += (this.language != null && this.language.trim() != '') ? ' ' + this.language.trim().toUpperCase() : '';
                    content += (time != null) ?' AT ' + this.formatDateTime(time, 'h:mmA', true, true) : '';
                    var base64EncodedMetaData = btoa(JSON.stringify(metaData));
                    this.$emit('beforeSectionsInsertOrUpdate');
                    Vue.nextTick(() => {
                        var interpreterStatusSection =
                            $('<div data-type="interpreter"/>')
                                .attr('id', metaData.SectionId)
                                .attr('data-metadata', base64EncodedMetaData)
                                .html(content)
                                .attr('data-content', content)
                                .data('content', content)
                                .insertAfter(this.currentEditorSection)[0];
                        if (this.mode == 'edit') {
                            $(this.currentEditorSection).remove(); //remove the old section
                        }
                        this.sectionsInsertedEventData = { sections: [interpreterStatusSection] };
                        this.dialogOpen = false;
                    });
                }
            },
            onDialogHidden: function () {
                this.reset();
                this.$emit('change', false);
                if (this.sectionsInsertedEventData) {
                    this.$emit('sectionsInserted', this.sectionsInsertedEventData);
                } else {
                    this.$emit('cancelled');
                }
                this.sectionsInsertedEventData = null;
            }
        }
    }
</script>
